import React from "react";
import { Button } from "@networkraildigitalfactory/components";

const EditActionButtons = (props) => {
  const { status, onSaveDraft, toggleDeleteModal, onEdit, isActionsDisabled, isDirtyForm } = props;
  switch (status) {
    case "draft":
      return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            color="red"
            text="Delete draft"
            name="delete draft"
            onClick={(e) => {
              e.preventDefault();
              toggleDeleteModal();
            }}
            id="deleteBtn"
          />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              disabled={isActionsDisabled || !isDirtyForm}
              color={isActionsDisabled || !isDirtyForm ? "grey" : "blue"}
              text="Save as draft"
              name="save as draft"
              onClick={onSaveDraft}
            />
            <Button
              disabled={isActionsDisabled}
              color={isActionsDisabled ? "grey" : "green"}
              text="Send for approval"
              name="send for approval"
              style={{ marginLeft: "2rem" }}
              onClick={onEdit}
            />
          </div>
        </div>
      );
    case "editing":
      return (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            disabled={isActionsDisabled || !isDirtyForm}
            color={isActionsDisabled || !isDirtyForm ? "grey" : "green"}
            text="Re-send for approval"
            name="re-send for approval"
            onClick={onEdit}
          />
        </div>
      );
    case "editing-no-change":
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            cursor: "not allowed",
            pointerEvents: "none",
          }}
        >
          <Button
            color="grey"
            text="Re-send for approval"
            name="re-send for approval"
            onClick={onEdit}
          />
        </div>
      );
    default:
      return <></>;
  }
};
export default EditActionButtons;
